import React from 'react';
import { ShieldIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
export const AboutSection = () => {
  return <section id="about" className="py-16 bg-white" data-id="element-11" data-mp="2ld84pa2tm0no">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12" data-mp="2gd3lhcaj2rtr">
        <div className="lg:text-center" data-id="element-13" data-mp="2gbirpow1fcwy">
          <h2 className="text-base text-[#D4AF37] font-semibold tracking-wide uppercase" data-id="element-14" data-mp="2be0o8e0shpwc">
            About Us
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-800 sm:text-4xl" data-id="element-15" data-mp="27cnj665itqqh">
            A Legacy of Trust and Excellence
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto" data-id="element-16" data-mp="1xmlw9howmed5">
            Founded with a mission to provide exceptional investment management
            for our close circle, we combine traditional wisdom with innovative
            strategies.
          </p>
        </div>
        <div className="mt-16" data-id="element-17" data-mp="1nqixmlt9gxuy">
          <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10" data-id="element-18" data-mp="1jmb4mcfrsvqx">
            <div className="relative" data-id="element-19" data-mp="srkoxu4thnsl">
              <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-[#D4AF37] text-white" data-id="element-20" data-mp="sqhzlqn57tes">
                <ShieldIcon size={24} aria-hidden="true" data-id="element-21" data-mp="xkvyw44xekoq" />
              </div>
              <h3 className="ml-16 text-lg leading-6 font-medium text-slate-800" data-id="element-22" data-mp="ivhoqttizz8a">
                Trust & Security
              </h3>
              <div className="mt-2 ml-16 text-base text-slate-600" data-id="element-23" data-mp="nqnansmxhdwd">
                We treat every investment with the same care and diligence as
                our own, maintaining the highest standards of integrity and
                transparency.
              </div>
            </div>
            <div className="relative" data-id="element-24" data-mp="12jyvd06ubil3">
              <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-[#D4AF37] text-white" data-id="element-25" data-mp="16ips367e8y7o">
                <TrendingUpIcon size={24} aria-hidden="true" data-id="element-26" data-mp="3n7bpwtebchxk" />
              </div>
              <h3 className="ml-16 text-lg leading-6 font-medium text-slate-800" data-id="element-27" data-mp="3r9yl94a70kzi">
                Strategic Growth
              </h3>
              <div className="mt-2 ml-16 text-base text-slate-600" data-id="element-28" data-mp="1xqg30recxq2o">
                Our investment philosophy balances growth opportunities with
                risk management for consistent, long-term results.
              </div>
            </div>
            <div className="relative" data-id="element-29" data-mp="1j2d23wf694kq">
              <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-[#D4AF37] text-white" data-id="element-30" data-mp="1j1k17c2w99ai">
                <UsersIcon size={24} aria-hidden="true" data-id="element-31" data-mp="1eyez3amq79me" />
              </div>
              <h3 className="ml-16 text-lg leading-6 font-medium text-slate-800" data-id="element-32" data-mp="1a0lrcd5ry7k0">
                Family Focus
              </h3>
              <div className="mt-2 ml-16 text-base text-slate-600" data-id="element-33" data-mp="15457hv5lyfcq">
                Currently managing investments exclusively for family and close
                friends, with plans to expand our services in the future.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};